import apiRequest from '@/js/helpers/apiRequest';
import { buildErrorCollection } from '@/js/utils/processingOpenApi';

/**
 * Проверка доступности phone для регистрации
 * @param phone {string} - телефон который проверяем
 * @returns {*}
 */
export default function checkPhoneAvailability(phone) {
  return new Promise((resolve, reject) => apiRequest.get('/user/check-phone-availability/', {
    phone,
  })
    .then((dataRes) => {
      if (dataRes.success) {
        return resolve(dataRes?.data?.data.attributes?.isAvailable);
      }
      throw new Error();
    })
    .catch((e) => {
      if (e.data) {
        const errors = buildErrorCollection(e.data);
        const [firstError] = errors;
        return reject(firstError);
      }
      return reject(e);
    }));
}
